import React from "react";
import { Link } from "react-router-dom";
import images from "../../../assets";
import { FREE_ASSESSMENT_URL } from "../../../constants/journey";
import { C, FONT } from "../../../constants/mq";

// Landing hero, laid out like mq.edu.au: a bright red panel cut on a diagonal
// over a photo, with a small red wedge in the far corner. The course finder
// card below overlaps its bottom edge.
//
// The headline is our own tagline, off the high school brochure. No location
// is named (campuses span regions and states) and no results claims are made;
// those need real material.
//
// The photo is a placeholder from the existing assets until we have one of
// our own classrooms.

const css = `
.cs-hero { position: relative; height: 430px; overflow: hidden; background: ${C.bright}; font-family: ${FONT}; }
.cs-hero__photo { position: absolute; inset: 0 0 0 30%; background-size: cover; background-position: 60% 40%; }
.cs-hero__panel { position: absolute; inset: 0; background: ${C.bright}; clip-path: polygon(0 0, 67% 0, 45% 100%, 0 100%); }
.cs-hero__wedge { position: absolute; inset: 0; background: ${C.bright}; clip-path: polygon(100% 58%, 100% 100%, 89% 100%); }
.cs-hero__inner { position: relative; max-width: 1072px; height: 100%; margin: 0 auto; padding: 0 24px; display: flex; align-items: center; }
.cs-hero__copy { max-width: 470px; padding-bottom: 70px; color: #fff; }
.cs-hero h1 { font-size: 46px; line-height: 1.16; font-weight: 800; letter-spacing: -0.5px; margin: 0 0 16px; color: #fff; }
.cs-hero p { font-size: 15.5px; line-height: 1.65; color: rgba(255,255,255,0.92); margin: 0 0 22px; }
.cs-hero__actions { display: flex; flex-wrap: wrap; align-items: center; gap: 22px; }
@media (max-width: 860px) {
  .cs-hero { height: auto; display: flex; flex-direction: column; }
  .cs-hero__inner { order: 1; padding-top: 44px; }
  .cs-hero__copy { padding-bottom: 36px; }
  .cs-hero__photo { position: relative; inset: auto; height: 260px; order: 2; }
  .cs-hero__panel, .cs-hero__wedge { display: none; }
  .cs-hero h1 { font-size: 34px; }
}
`;

const Hero = () => {
  const photo = images["bannerbg"]?.src;
  return (
    <section className="cs-hero">
      <style>{css}</style>
      <div
        className="cs-hero__photo"
        style={photo ? { backgroundImage: `url(${photo})` } : undefined}
        aria-hidden="true"
      />
      <div className="cs-hero__panel" aria-hidden="true" />
      <div className="cs-hero__wedge" aria-hidden="true" />
      <div className="cs-hero__inner">
        <div className="cs-hero__copy">
          <h1>
            The right tutoring,
            <br />
            at the right level
          </h1>
          <p>
            Our own courses, small classes and every assessment marked by us
            &mdash; Kindergarten to the HSC, since 2002.
          </p>
          <div className="cs-hero__actions">
            <Link className="mq-btn mq-btn--white" to="/enroll">
              Enrol now
            </Link>
            <a
              className="mq-link mq-link--white"
              href={FREE_ASSESSMENT_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Book a free assessment
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
